import React, { ReactNode } from "react";

import styles from "./styles.module.scss";

function Tooltip({
    tooltipMessage,
    children,
    className,
}: {
    tooltipMessage: string;
    children: ReactNode;
    className?: string;
}) {
    return (
        <div className={styles.tooltip}>
            {children}
            <span className={`${styles.toolTipText} ${className as string}`}>
                {tooltipMessage}
            </span>
        </div>
    );
}

export default Tooltip;
